/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
//import { useSelector } from 'react-redux';
import GlobalStateContext from '~/context/GlobalStateContext';
import { TweenMax, Linear, Power2 } from 'gsap/all';
import ScrollMagic from 'scrollmagic';
import configData from '~/config/data';
import DataLayer from '~/components/DataLayer';
import FiatBrand from '~/components/FiatBrand/FiatBrand';
import Arrow from './Arrow/Arrow';
import Features from './Features';
import Cover from './Cover';
import css from './MainPage.scss';

const classes = {
	root: css.mainPage,
	content: css.mainPageContent,
	cover: css.mainPageCover,
	features: css.mainPageFeatures,
	calls: css.mainPageCalls,
	callsButton: css.mainPageCallsButton,
	callsButtonIcon: css.mainPageCallsButtonIcon,
	callsButtonText: css.mainPageCallsButtonText,
	callsDecoration: css.mainPageCallsDecoration,
	callsDecorationStripes: css.mainPageCallsDecorationStripes,
	isSticky: css.isSticky,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	data: PropTypes.object,
};

const defaultProps = {
	className: '',
	classes,
	data: configData.cover,
};

export const MainPage = ({
	className,
	classes,
	location,
	mobile,
	cluster,
	data:info,
	...props
}) => {
	//const globalStateContext.menuToggleProgress = useSelector((state) => state.progress);
	const globalStateContext = React.useContext(GlobalStateContext);
	const rootRef = React.useRef();
	const coverRef = React.useRef();
	const contentRef = React.useRef();
	const featuresRef = React.useRef();
	const [progress, setProgress] = React.useState(1);
	const thumbList = React.useMemo(() => {
		return info.orderByClusterOrder(cluster.features.order);
	}, [location, cluster.slug]);

	const onLoadStart = (file) => {
		// n/a
	};

	const onLoadError = (file, xhr) => {
		// n/a
	};

	const onLoadProgress = (file, progress) => {
		// n/a
	};

	const onLoadComplete = (response) => {
		// n/a
	};

	React.useEffect(() => {
		const sticky = false;
		const controller = new ScrollMagic.Controller({
			globalSceneOptions: {
				triggerHook: 0,
			},
		});
		const scene = new ScrollMagic.Scene({
			triggerElement: contentRef.current,
			duration: sticky ? '50%' : '1%',
		});
		if (sticky) scene.setPin(contentRef.current);
		scene.setClassToggle(contentRef.current, classes.isSticky);
		scene.addTo(controller);
		scene.on('progress', (evt) => setProgress(evt.progress));
		return () => scene.destroy(true);
	}, []);

	React.useEffect(() => {
		if (coverRef.current) {
			coverRef.current.resize();
		}
		if (featuresRef.current) {
			featuresRef.current.update();
		}
	}, [globalStateContext.menuToggleProgress, mobile]);

	return (
		<section
			id={MainPage.displayName}
			data-ui-anchor={MainPage.displayName}
			className={cls(classes.root, className)}
			ref={rootRef}>
			<div className={cls(classes.content)} ref={contentRef}>
				{/*<Cover
					ref={coverRef}
					progress={progress}
					className={classes.cover}
					assets={info.data.covers[mobile ? 'mobile' : 'desktop']}
					mobile={mobile}
					noiseWidth={0}
					smoothMask={0.1}
					onLoadStart={onLoadStart}
					onLoadError={onLoadError}
					onLoadProgress={onLoadProgress}
					onLoadComplete={onLoadComplete}
				/>
				<img src="/assets/images/fiat-strada-praia.jpg" className={classes.cover}/>*/}
				<div className={classes.calls}>
					<button className={cls(classes.callsButton)}>
						<Arrow className={cls(classes.callsButtonIcon)} />
						<span
							className={cls(classes.callsButtonText)}
							dangerouslySetInnerHTML={{
								__html: 'Conocela'
							}}
						/>
					</button>
					{mobile && <div className={classes.callsDecoration} aria-hidden={true}>
						<FiatBrand
							className={classes.callsDecorationStripes}
							stripes={'none'}
							stroke={'#ffb80f'}
						/>
						<FiatBrand
							className={classes.callsDecorationStripes}
							stripes={'italian'}
							stroke={'none'}
						/>
					</div>}
				</div>
				<Features
					ref={featuresRef}
					className={classes.features}
					text={'La Fiat Strada que conocés se renovó como nunca para superarse.'}
					list={thumbList}
					mobile={mobile}
				/>
			</div>
		</section>
	);
}

MainPage.displayName = 'MainPage';
MainPage.propTypes = propTypes;
MainPage.defaultProps = defaultProps;
export default MainPage;
